module.exports = __webpack_public_path__ + "c8ea0942ac8279f3cd14935dbe0e3251.png";